(() => {
  'use strict';
  const button = document.querySelector('[data-reader-install]');
  const dialog = document.querySelector('[data-reader-install-dialog]');
  if (!button || !dialog) return;
  let installPrompt = null;
  window.addEventListener('beforeinstallprompt', event => { event.preventDefault(); installPrompt = event; });
  window.addEventListener('appinstalled', () => { installPrompt = null; button.hidden = true; });
  if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone) button.hidden = true;
  button.addEventListener('click', async () => {
    if (!installPrompt) { dialog.showModal(); return; }
    const prompt = installPrompt;
    installPrompt = null;
    try { await prompt.prompt(); await prompt.userChoice; } catch (_) { dialog.showModal(); }
  });
  dialog.addEventListener('close', () => button.focus());
})();
